import docsSidebar from "../../data/gatsby-sidebar/doc-links.yaml"

/*
  The YAML file for 'docs' has the following possible key/value pairs:
    title
    link
    key - this is "urlSegment".  Should not have to solve for it.
    breadcrumbTitle
    items
    disableExpandAll
    disableAccordions

  "Items" is a nests 'like' objects as the  "key's" object
  (i.e. a topic with subtopics).

  In addition, the following key/value pairs must be generated:
    hash - I thinkthis is to remove anything following a # in the link
    level - determine depth of nesting, used for formatting
    parentTitle

  Work required:
  1. Read in YAML file(s) - 1st doc only.
  2. Determine extent of nesting.
  3. Validate given key/value pairs.
  4. Create additional key/value pairs.
  5. Strip out hashes.
  
*/

const createHash = link => {
  let index = -1
  if (link) index = link.indexOf(`#`)
  return index >= 0 ? link.substr(index + 1) : false
}

const extendItem = (items, parentTitle, level) => {
  items.forEach(item => {
    item.parentTitle = parentTitle
    item.level = level || 1
    item.hash = createHash(item.link)

    if (item.items) {
      extendItem(item.items, item.title, item.level + 1)
    }
  })
}

const extendItemList = itemList => {
  itemList.forEach(section =>{
    section.level = 0
    if (section.items) extendItem(section.items, section.title)
  })
  return itemList
}

const  extendSidebarData = item => {
  // This function presumes there is a single top level object.
  // It is the defining object for all other objects it contains.
  return {
    title: item[0].title,
    breadcrumbTitle: item[0].breadcrumbTitle,
    key: item[0].key,
    disableAccordians: item[0].disableAccordians,
    disableExpandAll: item[0].disableExpandAll,
    items: extendItemList(item[0].items),
  }
}

const itemListDocs = extendSidebarData(docsSidebar)

const getItemList = path => {
//  const { basePath } = path
//  const [urlSegment] = basePath.split("/").slice(1)
  return itemListDocs
}

export {
  itemListDocs,
  getItemList
}